/**
 * Rewrite legacy notification `actionUrl` values so old in-DB rows still
 * land on a valid page after route renames.
 *
 * Notifications stored before a route move continue to surface in the
 * bell + center; we can't backfill them without an irreversible
 * migration, so we patch on read.
 *
 * Each clause matches a known stale path and returns the new canonical
 * surface. Unknown URLs pass through unchanged.
 */
export function rewriteLegacyActionUrl(url: string): string {
  // /notifications?chat=<id> → /mensajes?to=<id>
  // The Messages drawer used to live under /notifications; now /mensajes
  // is the canonical chat surface.
  const chatMatch = url.match(/^\/notifications(?:\.html?)?\?chat=([^&]+)/i);
  if (chatMatch) return `/mensajes?to=${chatMatch[1]}`;
  // Workflow detail pages moved under /library.
  const permitMatch = url.match(/^\/critical-task-permits\/(.+)$/);
  if (permitMatch) return `/library/permits/${permitMatch[1]}`;
  const evalMatch = url.match(/^\/initial-evaluations\/(.+)$/);
  if (evalMatch) return `/library/evaluations/${evalMatch[1]}`;
  const cardMatch = url.match(/^\/service-cards\/(.+)$/);
  if (cardMatch) return `/library/service-cards/${cardMatch[1]}`;
  // CompanyRelationship + onboarding admin pages were consolidated into
  // the /my-providers experience.
  if (/^\/company-relationships(\/|$|\?)/.test(url)) return '/my-providers';
  if (url === '/provider-onboarding' || url.startsWith('/provider-onboarding?')) {
    return '/my-providers';
  }
  return url;
}
